exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div_ActiveUsers_userData{\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n}\n.div_ActiveUsers_userData div{\n    flex: 1 1;\n}", ""]);

// exports
